import React from 'react'
import {Container,Table} from 'react-bootstrap';
import Title from '../../utilities/other/title';
import Questions_Table from './questionnaire_custom_answers'
import History from './history.json';
import Mentation from './mentation.json';
import Bullbar from './bullbar.json';
import Ocular_motor from './ocular_motor.json';
import Limb_motor from './Limb_motor.json';
import Gait_midline from './Gait_midline';
class Psp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            score:0,
            mod_score:0
        }
    }
    handleScore = (val,modval) => {
        if (!isNaN(val)){
            this.setState((prevState) => 
                        ({
                            ...prevState,
                            score:prevState.score + (val),
                           

                        })
                        
            )
        }
        if(!isNaN(modval)){
            this.setState((prevState) => 
                        ({
                            ...prevState,
                            mod_score:prevState.mod_score + (modval),
                           

                        })
                        
            )
        }
    }
    onChange = async (event) => {
        const {name,value} = event.target
        
       await this.setState((prevState)=>({
            ...prevState,
            
           
                [name]:value
            
        }))
        this.props.handler('psp',this.state)
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    // componentDidUpdate(prevProps, prevState){
    //     if (prevState != this.state){
    //        this.props.handler('psp',this.state)
    //     }
    //     // if (prevState != this.state){
    //     // }
    // }

    render() {
        return (
            <Container>
            <Title> Progressive Supranuclear Palsy Scale </Title>
            
            <h5>History</h5>
            <Questions_Table disabled={this.props.disabled} score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={History} answers={History} handler={this.onChange} />
            <h5>Mentation</h5>
            <Questions_Table  disabled={this.props.disabled} score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={Mentation} answers={Mentation} handler={this.onChange} fieldName={'fab'} hideHeader={true}/>
            <h5>Bullbar</h5>
            <Questions_Table disabled={this.props.disabled}  score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={Bullbar} answers={Bullbar} handler={this.onChange} fieldName={'fab'} hideHeader={true}/>
            <h5>Ocular motor</h5>
            <Questions_Table disabled={this.props.disabled}  score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={Ocular_motor} answers={Ocular_motor} handler={this.onChange} fieldName={'fab'} hideHeader={true}/>
            <h5>Limb motor</h5>
            <Questions_Table disabled={this.props.disabled}  score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={Limb_motor} answers={Limb_motor} handler={this.onChange} fieldName={'fab'} hideHeader={true}/>
            <h5>Gaid and Midline</h5>
            <Questions_Table  disabled={this.props.disabled} score={true} data={this.props.data!=null?this.props.data:null} scoreFunc={this.handleScore}  questions={Gait_midline} answers={Gait_midline} handler={this.onChange} fieldName={'fab'} hideHeader={true} />
            <Table>
                <thead>
                    <tr>
                        <th>PSP Score</th>
                        <th>{this.state.score}</th>
                    </tr>
                    <tr>
                        <th>Modified PSP Score</th>
                        <th>{this.state.mod_score}</th>
                    </tr>
                </thead>
                
            </Table>
            </Container>
        )
        }

}
Psp.defaultProps = {
    disabled: false,
}
export default Psp;